// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Admin_pageContainer__qi5gy"};